import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import {
  FaSave,
  FaSearch,
  FaFacebookSquare,
  FaInstagramSquare,
  FaWhatsappSquare,
  FaBuilding,
  FaMapMarkerAlt,
  FaPhone,
  FaShareAlt,
  FaClock,
} from 'react-icons/fa';
import TextImageIcon from '@rsuite/icons/TextImage';
import { toastSuccess, toastError } from '../../toasts';
import axios from 'axios';
import { Container } from 'rsuite';
import * as S from './styles';
import { useAuth } from '../../hooks/auth';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomButton } from '../../components/CustomButton';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomInput } from '../../components/CustomInput';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomMaskedInput } from '../../components/CustomMaskedInput';

const options = [
  {
    name: 'Celular',
    mask: [
      '(',
      /[1-9]/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    placeholder: '(63) 33333-3333',
  },
  {
    name: 'CPF',
    mask: [
      /[/0-9]/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ],
    placeholder: '999.999.999-99',
  },
  {
    name: 'CNPJ',
    mask: [
      /[/0-9]/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '/',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ],
    placeholder: '99.999.999/9999-99',
  },
  {
    name: 'CEP',
    mask: [/[/0-9]/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
    placeholder: '99.999.999/9999-99',
  },
];

const defaultFormState = {
  id: '',
  cnpj: '',
  razao: '',
  fantasia: '',
  cep: '',
  logradouro: '',
  bairro: '',
  numero: '',
  cidade: '',
  estado: '',
  email: '',
  telefone: '',
  celular: '',
  site: '',
  facebook: '',
  instagram: '',
  tempoEntrega: '',
};
const placeholderChar = '_';

function Field({ label, icon, required, minWidth, grow, children }) {
  return (
    <S.Field $minWidth={minWidth} $grow={grow}>
      <S.FieldLabel>
        {icon}
        {label}
        {required && <S.RequiredDot />}
      </S.FieldLabel>
      {children}
    </S.Field>
  );
}

export default function Empresa() {
  const { id_empresa } = useAuth();
  const { theme } = useCustomTheme();
  const [form, setForm] = useState(defaultFormState);
  const [tempos, setTempos] = useState([]);

  const dataTempo = tempos.map((item) => ({
    label: item.Descricao,
    value: item.Id,
  }));

  const atualizar = async () => {
    api
      .get('tempo/listar')
      .then((res) => {
        setTempos(res.data);
      })
      .catch((error) => console.log(error));
    api
      .get(`empresa/encontrar/${id_empresa}`)
      .then(({ data }) => {
        setForm({
          id: data.Id,
          cnpj: data.Cnpj,
          razao: data.RazaoSocial,
          fantasia: data.NomeFantasia,
          cep: data.Cep,
          logradouro: data.Logradouro,
          bairro: data.Bairro,
          numero: data.Numero,
          cidade: data.Cidade,
          estado: data.Estado,
          email: data.Email,
          telefone: data.Telefone,
          celular: data.Celular,
          site: data.Site,
          facebook: data.Facebook,
          instagram: data.Instagram,
          tempoEntrega: data.IdTempo,
        });
      })
      .catch((error) => console.log(error));
  };

  const onChangeForm = (field) => {
    return (value = '') => {
      setForm((state) => ({ ...state, [field]: value }));
    };
  };

  const validarCampos = () => {
    const {
      razao,
      fantasia,
      cnpj,
      cep,
      bairro,
      cidade,
      estado,
      telefone,
      tempoEntrega,
    } = form;

    return (
      razao &&
      fantasia &&
      cnpj &&
      cep &&
      bairro &&
      cidade &&
      estado &&
      telefone &&
      tempoEntrega
    );
  };

  const alterarDados = async () => {
    if (validarCampos()) {
      api
        .patch(`empresa/alterar-menucheff/${form.id}`, {
          Cep: form.cep,
          Logradouro: form.logradouro,
          Bairro: form.bairro,
          Numero: form.numero,
          Cidade: form.cidade,
          Estado: form.estado,
          Email: form.email,
          Telefone: form.telefone,
          Celular: form.celular,
          Site: form.site,
          Facebook: form.facebook,
          Instagram: form.instagram,
          IdTempo: form.tempoEntrega,
        })
        .then(() => {
          toastSuccess('Dados alterados');
        })
        .catch((error) => {
          console.log(error);
          toastError('Erro ao alterar dados');
        });
    } else {
      toastError('Preencha os campos obrigatórios');
    }
  };

  const buscarCep = () => {
    if (form.cep) {
      let cepPesquisa = form.cep.replace(/\D+/g, '');
      axios
        .get(`https://viacep.com.br/ws/${cepPesquisa}/json/`)
        .then(({ data }) => {
          if (data.erro !== true) {
            setForm((state) => ({
              ...state,
              logradouro: data.logradouro,
              bairro: data.bairro,
              cidade: data.localidade,
              estado: data.uf,
            }));
          } else {
            toastError('CEP não encontrado');
          }
        })
        .catch((error) => console.log(error));
    } else {
      toastError('Informe o CEP');
    }
  };

  useEffect(() => {
    atualizar();
  }, []);

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Dados da Empresa"
        subtitle="Gerencie os dados da sua empresa"
        icon={TextImageIcon}
        growTitle={true}
        thirdComponent={<DuvidasButton tela="empresa" />}
      />

      <S.PageScroll>
        <S.BentoGrid>
          <S.BentoCard $span={7}>
            <S.CardHeader>
              <S.CardIconBadge>
                <FaBuilding size={16} />
              </S.CardIconBadge>
              <S.CardTitleGroup>
                <S.CardTitle>Identificação</S.CardTitle>
                <S.CardSubtitle>Dados cadastrais da empresa</S.CardSubtitle>
              </S.CardTitleGroup>
            </S.CardHeader>
            <S.FieldsGrid>
              <Field label="CNPJ" required minWidth="180px">
                <CustomMaskedInput
                  value={form.cnpj}
                  mask={options[2].mask}
                  guide={false}
                  showMask={true}
                  keepCharPositions={false}
                  placeholder={options[2].placeholder}
                  placeholderChar={placeholderChar}
                  style={{ width: '100%' }}
                  onChange={onChangeForm('cnpj')}
                  disabled
                />
              </Field>
              <Field label="Razão Social" required grow={2} minWidth="200px">
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.razao}
                  onChange={onChangeForm('razao')}
                  disabled
                />
              </Field>
              <Field label="Nome Fantasia" required grow={2} minWidth="200px">
                <CustomInput
                  type="text"
                  style={{ width: '100%' }}
                  value={form.fantasia}
                  onChange={onChangeForm('fantasia')}
                  disabled
                />
              </Field>
            </S.FieldsGrid>
          </S.BentoCard>

          <S.BentoCard $span={5} $accent>
            <S.CardHeader>
              <S.CardIconBadge>
                <FaClock size={16} />
              </S.CardIconBadge>
              <S.CardTitleGroup>
                <S.CardTitle>Operação</S.CardTitle>
                <S.CardSubtitle>
                  Tempo estimado exibido no cardápio
                </S.CardSubtitle>
              </S.CardTitleGroup>
            </S.CardHeader>
            <Field label="Tempo de Entrega" required>
              <CustomSelectPicker
                data={dataTempo}
                style={{ width: '100%' }}
                onChange={onChangeForm('tempoEntrega')}
                value={form.tempoEntrega}
                searchable={false}
              />
            </Field>
          </S.BentoCard>

          <S.BentoCard $span={12}>
            <S.CardHeader>
              <S.CardIconBadge>
                <FaMapMarkerAlt size={16} />
              </S.CardIconBadge>
              <S.CardTitleGroup>
                <S.CardTitle>Endereço</S.CardTitle>
                <S.CardSubtitle>
                  Utilizado para o cálculo de entrega e localização no mapa
                </S.CardSubtitle>
              </S.CardTitleGroup>
            </S.CardHeader>
            <S.FieldsGrid>
              <Field label="Cep" required minWidth="200px">
                <S.FieldInputRow>
                  <CustomMaskedInput
                    value={form.cep}
                    mask={options[3].mask}
                    guide={false}
                    showMask={true}
                    keepCharPositions={false}
                    placeholder={options[3].placeholder}
                    placeholderChar={placeholderChar}
                    onChange={onChangeForm('cep')}
                    style={{ width: '100%' }}
                  />
                  <CustomButton type="button" appearance="primary" onClick={buscarCep}>
                    <FaSearch />
                  </CustomButton>
                </S.FieldInputRow>
              </Field>
              <Field label="Endereço" grow={2} minWidth="220px">
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.logradouro}
                  onChange={onChangeForm('logradouro')}
                />
              </Field>
              <Field label="Número" minWidth="100px" grow={0.5}>
                <CustomInput
                  style={{ width: '100%' }}
                  type="number"
                  value={form.numero}
                  onChange={onChangeForm('numero')}
                />
              </Field>
              <Field label="Bairro" required minWidth="180px">
                <CustomInput
                  type="text"
                  style={{ width: '100%' }}
                  value={form.bairro}
                  onChange={onChangeForm('bairro')}
                />
              </Field>
              <Field label="Cidade" required minWidth="180px">
                <CustomInput type="text" style={{ width: '100%' }} value={form.cidade} disabled />
              </Field>
              <Field label="Estado" required minWidth="100px" grow={0.5}>
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.estado}
                  disabled
                />
              </Field>
            </S.FieldsGrid>
          </S.BentoCard>

          <S.BentoCard $span={6}>
            <S.CardHeader>
              <S.CardIconBadge>
                <FaPhone size={16} />
              </S.CardIconBadge>
              <S.CardTitleGroup>
                <S.CardTitle>Contato</S.CardTitle>
                <S.CardSubtitle>Canais para o cliente falar com você</S.CardSubtitle>
              </S.CardTitleGroup>
            </S.CardHeader>
            <S.FieldsGrid>
              <Field label="Email" grow={2} minWidth="200px">
                <CustomInput
                  style={{ width: '100%' }}
                  type="email"
                  value={form.email}
                  onChange={onChangeForm('email')}
                />
              </Field>
              <Field label="Telefone" required minWidth="170px">
                <CustomMaskedInput
                  value={form.telefone}
                  mask={options[0].mask}
                  guide={false}
                  showMask={true}
                  keepCharPositions={false}
                  placeholder={options[0].placeholder}
                  placeholderChar={placeholderChar}
                  style={{ width: '100%' }}
                  onChange={onChangeForm('telefone')}
                />
              </Field>
              <Field
                label="WhatsApp"
                icon={<FaWhatsappSquare size={16} color="#34af23" />}
                minWidth="170px"
              >
                <CustomMaskedInput
                  value={form.celular}
                  mask={options[0].mask}
                  guide={false}
                  showMask={true}
                  keepCharPositions={false}
                  placeholder={options[0].placeholder}
                  placeholderChar={placeholderChar}
                  style={{ width: '100%' }}
                  onChange={onChangeForm('celular')}
                />
              </Field>
            </S.FieldsGrid>
          </S.BentoCard>

          <S.BentoCard $span={6}>
            <S.CardHeader>
              <S.CardIconBadge>
                <FaShareAlt size={16} />
              </S.CardIconBadge>
              <S.CardTitleGroup>
                <S.CardTitle>Redes Sociais</S.CardTitle>
                <S.CardSubtitle>Divulgue seus canais para os clientes</S.CardSubtitle>
              </S.CardTitleGroup>
            </S.CardHeader>
            <S.FieldsGrid>
              <Field label="Site" minWidth="180px">
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.site}
                  onChange={onChangeForm('site')}
                />
              </Field>
              <Field
                label="Facebook"
                icon={<FaFacebookSquare size={16} color="#4267b2" />}
                minWidth="180px"
              >
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.facebook}
                  onChange={onChangeForm('facebook')}
                />
              </Field>
              <Field
                label="Instagram"
                icon={<FaInstagramSquare size={16} color="#DD2A7B" />}
                minWidth="180px"
              >
                <CustomInput
                  style={{ width: '100%' }}
                  type="text"
                  value={form.instagram}
                  onChange={onChangeForm('instagram')}
                />
              </Field>
            </S.FieldsGrid>
          </S.BentoCard>
        </S.BentoGrid>

        <S.SaveBar>
          <CustomButton appearance="primary" onClick={alterarDados}>
            <FaSave style={{ marginRight: 16, width: " 100%"}} /> Salvar
          </CustomButton>
        </S.SaveBar>
      </S.PageScroll>
    </Container>
  );
}
